export type StorageOptionsStatus = {
  indexedDB: boolean
  local: boolean
  session: boolean
  cookies: boolean
}

//Cached storage names
export const STORAGE_NAMES = {
  seasonEvents: 'pll_season_events',
  home_feed: 'home_feed',
  home_shop_collection: 'home_shop_collection',
  banners: 'banners',
  standings: 'standings',
  pll_play: 'pll_play_data',
  app_config: 'pll_app_config',
  team_data: 'pll_team_data',
  selectedPlayersASG: 'selectedPlayersASG',
  allStarVoteDate: 'allStarVoteDate',
  tempEmail: 'pll_temp_em', // Used for email sign-in flow
}

export const MAX_CACHE_TIME = 1000 * 60 * 60 * 24 * 5 // 5 days
